import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { ICampJourneeType } from '../model/camp-journee-type.model';
import { Moment } from 'moment';
import {CAMP_INFO_GENERALE_STATUS, PROJET_ANNEE_AVIS_MARIN, PROJET_ANNEE_STATUS} from '../constant/constant';
import { CampOngletInformationsGeneralesComponent } from "../../camp/camp-onglets/camp-onglet-informations-generales/camp-onglet-informations-generales.component";

const CODE_LENGTH = 9;

export function checkCampStructuresOrganizers(control: AbstractControl): { [key: string]: string } | null {
  const campStructures = control.value;
  const organisateurs = [];
  if (campStructures && campStructures.length > 0) {
    campStructures.forEach(campStructure => {
      if (campStructure.organisatrice === true) {
        organisateurs.push(campStructure);
      }
    });
    if (organisateurs.length == 0) {
      return {errorMessage: 'Vous ne pouvez pas créer de camp sans structure organisatrice'};
    } else if (organisateurs.length > 1) {
      return {errorMessage: 'Vous ne pouvez pas créer de camp avec plus d\'une structure organisatrice'};
    } else if (organisateurs.length === 1) {
      return null;
    }
  }
}

export function checkCampLieuPrincipal(control: AbstractControl): { [key: string]: string } | null {
  const campLieuPrincipal = control.value;
  if (campLieuPrincipal && campLieuPrincipal.id !== null && campLieuPrincipal.id !== undefined) {
    return null;
  } else {
    return {errorMessage: 'Vous devez sélectionner un lieu principal'};
  }
}

export function checkCodeEntry(control: AbstractControl): { [key: string]: boolean } | null {
  const value = control.value;
  if (value != '' && value != undefined && value != null) {
    const code = parseInt(value, 10);
    if (value.toString().length === CODE_LENGTH && !isNaN(code) && code.toString().length === CODE_LENGTH) {
      return null;
    } else {
      return {invalid: true};
    }
  } else {
    return null;
  }
}

export function checkDuplicateTiming(formArray: FormArray): { [key: string]: string } | null {
  const formArrayValue: ICampJourneeType[] = formArray.value;
  if (formArrayValue && formArrayValue.length > 0) {
    const timingValues: string[] = [];
    const duplicateTimingsIndices: number[] = [];
    formArrayValue.forEach((campJourneeType: ICampJourneeType, i: number) => {
      formArray.controls[i].setErrors(null);
      const index = timingValues.indexOf(campJourneeType.heureDebut);
      if (index === -1) {
        timingValues.push(campJourneeType.heureDebut);
      } else {
        const _index = duplicateTimingsIndices.indexOf(index);
        if (_index === -1) {
          duplicateTimingsIndices.push(index);
        }
        duplicateTimingsIndices.push(i);
      }
    });
    if (duplicateTimingsIndices.length > 0) {
      duplicateTimingsIndices.forEach(index => {
        formArray.controls[index].setErrors({errorMessage: 'Des doublons en heures ont été détectés'});
      });
      return {errorMessage: 'Des doublons en heures ont été détectés'};
    }
  }
  return null;
}

export function checkDates(dateDebutControlName: string, dateFinControlName: string, datesInterval?: Moment[], errorMessage?: string) {
  return (formGroup: FormGroup): { [key: string]: string } | null => {
    const dateDebutControl = formGroup.get(dateDebutControlName);
    const dateFinControl = formGroup.get(dateFinControlName);
    const dateDebut = dateDebutControl.value;
    const dateFin = dateFinControl.value;
    if (dateDebut && dateFin) {
      dateFinControl.setErrors(null);
      dateDebutControl.setErrors(null);
      if (dateDebut.isAfter(dateFin)) {
        const error = {errorMessage: 'La date de fin doit être supérieure à la date de début'};
        dateFinControl.setErrors(error);
        dateFinControl.markAsTouched();
        return error;
      } else if (datesInterval && datesInterval.length > 0) {
        let error_flag = false;
        if (dateDebut.isBefore(datesInterval[0],'day')) {
          dateDebutControl.setErrors({errorMessage: errorMessage});
          error_flag = true;
        }
        if (dateFin.isAfter(datesInterval[1])) {
          dateFinControl.setErrors({errorMessage: errorMessage});
          error_flag = true;
        }
        if (error_flag) {
          return {errorMessage: 'Veuillez respecter l\'intervalle de dates'};
        }
      }
    }
    return null;
  }
}

export function checkIfNumericValue (control: AbstractControl): { [key: string]: string } | null {
  const value = control.value;
  if (value != '' && value != undefined && value != null) {
    control.setErrors(null);
    const regExp = new RegExp('^([+\d])([0-9]+)','g');
    if (value.match(regExp)) {
      return null;
    } else {
      control.setErrors({errorMessage: 'Entrez une valeur numérique d\'une longueur maximale de 20'});
    }
  }
}

// FIXME: This is not a form validator, it is a normal function that is used in different places and it should moved to an appropriate file
export function disableCodeSubmitButton(control: AbstractControl) {
  const value = control.value;
  if (value === '' || value === undefined || value === null ||
    (control.errors && control.errors.invalid === true)) {
    return true;
  } else {
    return false;
  }
}

export function getFormArrayRowsSwitched(i: number, j: number, formArray: FormArray, formAttributes: string[], slotsNumber: number = 1): FormArray {
  formAttributes.forEach(attribute => {
    for (let counter = 0; counter < slotsNumber; counter++) {
      const buffer = formArray.controls[j + counter].get(attribute).value;
      formArray.controls[j + counter].get(attribute).setValue(formArray.controls[i + counter].get(attribute).value);
      formArray.controls[i + counter].get(attribute).setValue(buffer);
    }
  });
  return formArray;
}

export function getStatusText(statusValue) {
  const status = CAMP_INFO_GENERALE_STATUS.find(status => status.value === statusValue);
  return status ? status.text : '';
}

export function getProjetAnneeStatusText(statusValue) {
  const status = PROJET_ANNEE_STATUS.find(status => status.value === statusValue);
  return status ? status.text : '';
}

export function getProjetAnneeVisaMarinStatusText(statusValue) {
  const status = PROJET_ANNEE_AVIS_MARIN.find(avis => avis.value === statusValue);
  return status ? status.text : '';
}

export function checkNbreJeunes(controlName?: string, module?:string) {
  return (formGroup: FormGroup): { [key: string]: string } | null => {
    const camp817FormGroup = formGroup.get(controlName);
    if(camp817FormGroup) {
      camp817FormGroup.setErrors(null);
      const previsionNbreParticipants = camp817FormGroup.get('previsionNbreParticipants').value;
      const previsionNbreFilles = camp817FormGroup.get('previsionNbreFilles').value;
      const previsionNbreGarcons = camp817FormGroup.get('previsionNbreGarcons').value;
      const previsionNbre613 = camp817FormGroup.get('previsionNbre613').value;
      const previsionNbre1417 = camp817FormGroup.get('previsionNbre1417').value;
      const previsionNbreHandicap = camp817FormGroup.get('previsionNbreHandicap').value;
      if(module === CampOngletInformationsGeneralesComponent.MODULE_NAME){
        if(
          !isNaN(previsionNbreParticipants) &&
          !isNaN(previsionNbreFilles) &&
          !isNaN(previsionNbreGarcons) &&
          (previsionNbreFilles + previsionNbreGarcons == previsionNbreParticipants)
        ) {
          return null;
        }else {
            camp817FormGroup.setErrors(
              {
                'message': '<ul>' +
                  '<li>Le champ nombre de jeunes doit être égal à la somme du nombre de filles et de garçons</li>' +
                  '</ul>'
              }
            );
          return {'message': 'Information error'};
        }
      }
    }
  }
}
